module.exports = __webpack_public_path__ + "static/media/thousandsOfLists.c6d234e7.png";